import { Box, Button, Typography } from "@mui/material";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";

import { identifiersData, namesData } from "@/data";
import { theme } from "@/theme";

const DownloadBox = ({ id, link, message }) => {
    const { t } = useTranslation();

    const { button: buttonId } = identifiersData.ids;

    const { download: downloadButtonName } = namesData.buttons;

    return (
        <Box>
            <Typography
                variant="body1"
                sx={{
                    fontSize: 14,
                }}
            >
                {message}
            </Typography>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                }}
            >
                <a
                    href={`${import.meta.env.VITE_BACKEND_DOMAIN}${link}`}
                    style={{
                        color: theme.palette.primary.main,
                        textDecoration: "none",
                    }}
                >
                    <Button
                        id={
                            id ? `${id}_${downloadButtonName}_${buttonId}` : `${namesData.buttons.download}_${buttonId}`
                        }
                        size="small"
                        variant="outlined"
                    >
                        {t("actions.download")}
                    </Button>
                </a>
            </Box>
        </Box>
    );
};

export default DownloadBox;

DownloadBox.propTypes = {
    id: PropTypes.string,
    link: PropTypes.string,
    message: PropTypes.string,
};
